import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  token: null,
  title: 'Gritus',
  userData: { display_name: null },
  locationsData: null,
  machinesData: null,
  currentLocationData: null,

  setupSmooch: false,
  smoochToken: null
}

const getters = {
  hasLoggedIn (state) {
    return state.token && state.locationsData && state.machinesData
  }
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
  },

  SET_TITLE (state, title) {
    state.title = title
  },

  SET_USER_DATA (state, data) {
    state.userData = data
  },

  SET_CURRENT_WITHDRAWAL (state, data) {
    state.userData.current_withdrawal = data
  },

  SET_LOCATIONS_DATA (state, data) {
    state.locationsData = data
  },

  SET_MACHINES_DATA (state, data) {
    state.machinesData = data
  },

  SET_CURRENT_LOCATION_DATA (state, data) {
    state.currentLocationData = data
  },

  LOGOUT (state) {
    state.token = null
    state.smoochToken = null
    state.userData = { display_name: null }
    state.locationsData = null
    state.currentLocationData = null
    state.machinesData = null
  },

  SET_SMOOCH_TOKEN (state, token) {
    state.smoochToken = token
  },

  SETUP_SMOOCH (state) {
    state.setupSmooch = true
  },

  DESTROY_SMOOCH (state) {
    state.setupSmooch = false
  }
}

const plugins = [
  createPersistedState({
    paths: ['token', 'smoochToken', 'userData', 'locationsData', 'currentLocationData', 'machinesData'],
    storage: window.sessionStorage
  })
]

export default new Vuex.Store({
  state,
  getters,
  mutations,
  plugins
})
